// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deleteIcon[data-v-74c4f22f]{font-size:18px;position:absolute;right:15px;top:15px;cursor:pointer;z-index:1}[data-v-74c4f22f] .el-dialog__header{border-bottom:1px solid #ebebeb;padding-bottom:15px}[data-v-74c4f22f] .el-drawer__header{border-bottom:1px solid #ebebeb;padding:10px 20px;margin-bottom:0}.buildDetail[data-v-74c4f22f] .el-dialog__body,[data-v-74c4f22f] .el-drawer__body{padding:0}", ""]);
// Exports
module.exports = exports;
